export default {
  title: 'Lisäosat suurempaa menestystä varten',
  description: 'Päivitä suunnitelmaasi lisäominaisuuksilla',
  buttons: {
    continue: 'Jatka',
    no_app_for_now: 'Ei mobiilisovellusta toistaiseksi',
  },
  toasts: {
    something_went_wrong: 'Jokin meni pieleen, yritä päivittää sivu tai ota yhteyttä tekniseen tukeen!',
    failed_to_save_changes: 'Muutoksia ei voitu tallentaa, ota yhteyttä tekniseen tukeen!',
    changes_got_saved: 'Muutokset tallennettiin onnistuneesti!',
  },
};
